module.exports = __webpack_public_path__ + "img/bk_510.5702d84e.png";